import axios from "./axios";
import { getConfig } from "../utils/sessionStorageUtils";

export const getSearchText = async (searchText: string) => {
    try {
        const result = await axios.get(`/Search/12/0?text=${searchText}`, getConfig());
        return result.data;
    } catch (e) {
        console.error(e);
    }
}
export const getSearchFilters = async (searchText: string) => {
    try {
        const result = await axios.get(`/Filters/products?searchtext=${searchText}`, getConfig());
        return result.data;
    } catch (e) {
        console.error(e);
    }
};